






































































































































import { PageModeMixin } from '@/main/mixins/pageMode';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { store } from '../store/edit';

export default PageModeMixin.extend({
	name: 'AplikaceNastaveni',
	props: {
		storeUri: { type: String, required: true },
	},
	computed: {
		...genVuexComputeds(store),
	},
});
